import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';

import Arrow from 'Assets/images/icons/arrow-rounded-right.svg';

interface InteractOpenSignPanelButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
}

const InteractOpenSignPanelButton = forwardRef<
  HTMLButtonElement,
  InteractOpenSignPanelButtonProps
>((props: InteractOpenSignPanelButtonProps, ref) => {
  const { className, text = 'Sign', ...buttonProps } = props;
  return (
    <button
      ref={ref}
      className={classNames(
        'interactModal__fieldBar-selectField-item-openSignPanel-button',
        className,
      )}
      {...buttonProps}
    >
      <span className="interactModal__fieldBar-selectField-item-openSignPanel-text">
        {text}
      </span>
      <ReactSVG
        src={Arrow}
        className="interactModal__fieldBar-selectField-item-openSignPanel"
      />
    </button>
  );
});

InteractOpenSignPanelButton.displayName = InteractOpenSignPanelButton.name;

export default InteractOpenSignPanelButton;
